var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"button-wrp"},_vm._l((_vm.list),function(v,i){return _c('div',{key:i,class:`item ${v.value === _vm.selected ? 'selected' : ''}`,on:{"click":function($event){return _vm.handleClick(v)}}},[_c('span',[_vm._v(_vm._s(v.label))])])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }